import React, { useEffect, useState, useRef } from 'react';
import { Icon } from '@iconify/react';
const CARD_SHADOW = 'none';
const CARD_BORDER = '1px solid #E4E4E4';
interface FaqRow {
  id: number;
  domanda: string;
  risposta: string;
  categoria: string;
  tags: string[];
}
const initialFaqs: FaqRow[] = [{
  id: 1,
  domanda: 'Con riferimento al Bando 4, è possibile prese...',
  risposta: "Sì, purché come indicato all'art. 2 del Bando 4 'Live e promo...",
  categoria: 'BANDO 4',
  tags: ['ammissibilità progetti', 'bando 4', 'contributi MiC']
}, {
  id: 2,
  domanda: 'Con riferimento al Bando 3, gli artisti under3...',
  risposta: 'Non necessariamente. In sede di presentazione della propos...',
  categoria: 'BANDO 3',
  tags: ['ammissibilità progetti', 'artisti', 'bando 3']
}, {
  id: 3,
  domanda: "Cosa si intende per 'istituzioni scolastiche e...",
  risposta: 'La definizione comprende le scuole primarie e scuole secon...',
  categoria: 'BANDO 2',
  tags: ['ammissibilità soggetto prop...', 'bando 2']
}, {
  id: 4,
  domanda: "Con riferimento al Bando 1 'Nuove opere', la ...",
  risposta: "No, il Bando 1 'Nuove opere' prevede esclusivamente che l'o...",
  categoria: 'BANDO 1',
  tags: ['ammissibilità progetti', 'bando 1']
}, {
  id: 5,
  domanda: 'Per i Bandi 1, 3 e 4, nel caso di assegnazione...',
  risposta: "Sì, all'art. 5.1 del Bando 1 'Nuove opere', del Bando 3 'Profe...",
  categoria: 'ASPETTI GENERALI > RENDICONTAZIONE',
  tags: ['bando 1', 'bando 3', 'bando 4', 'erogazione', 'rendicontazioni']
}, {
  id: 6,
  domanda: 'È possibile presentare proposte progettuali c...',
  risposta: 'Sì, purché tali artisti (o studenti nel caso del Bando 2) siano...',
  categoria: 'ASPETTI GENERALI > ARTISTI',
  tags: ['artisti', 'studenti']
}, {
  id: 7,
  domanda: 'In quale settore artistico può essere candida...',
  risposta: "Un progetto riguardante l'arte circense/l'arte di strada può e...",
  categoria: 'ASPETTI GENERALI > PROPOSTE PROGETTUALI',
  tags: ['ammissibilità progetti', 'arti visive', 'teatro']
}];
const categorieOptions = ['TUTTI', 'BANDO 1', 'BANDO 2', 'BANDO 3', 'BANDO 4', 'ASPETTI GENERALI > RENDICONTAZIONE', 'ASPETTI GENERALI > ARTISTI', 'ASPETTI GENERALI > PROPOSTE PROGETTUALI', "ASPETTI GENERALI > INCOMPATIBILITA' CON CONTRIBUTI MIC", 'ASPETTI GENERALI > REQUISITI PER PARTECIPARE'];
const CategoriaBadge = ({
  label
}: {
  label: string;
}) => <span style={{
  backgroundColor: '#f5f5f5',
  color: '#333',
  fontSize: '12px',
  textTransform: 'uppercase',
  padding: '4px 8px',
  fontWeight: 500,
  fontFamily: 'Roboto, sans-serif',
  display: 'inline-block',
  whiteSpace: 'nowrap',
  maxWidth: '200px',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}} title={label} data-id="element-1120">
    {label}
  </span>;
const TagPill = ({
  label
}: {
  label: string;
}) => <span style={{
  backgroundColor: '#2196F3',
  color: 'white',
  fontSize: '11px',
  borderRadius: '12px',
  padding: '2px 8px',
  margin: '2px',
  fontFamily: 'Roboto, sans-serif',
  display: 'inline-block',
  whiteSpace: 'nowrap'
}} data-id="element-1121">
    {label}
  </span>;
const filterInputStyle: React.CSSProperties = {
  width: '100%',
  height: '28px',
  padding: '0 6px',
  border: '1px solid #E4E4E4',
  borderRadius: '8px',
  fontSize: '11px',
  fontFamily: 'Roboto, sans-serif',
  color: '#444',
  outline: 'none',
  backgroundColor: 'white'
};
const filterSelectStyle: React.CSSProperties = {
  width: '100%',
  height: '28px',
  padding: '0 4px',
  border: '1px solid #E4E4E4',
  borderRadius: '8px',
  fontSize: '11px',
  fontFamily: 'Roboto, sans-serif',
  color: '#444',
  outline: 'none',
  backgroundColor: 'white'
};
export function GestioneFAQ() {
  const [searchQuery, setSearchQuery] = useState('');
  const [filters, setFilters] = useState({
    domanda: '',
    risposta: '',
    categoria: 'TUTTI',
    tag: ''
  });
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [azioniOpen, setAzioniOpen] = useState(false);
  const azioniRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (azioniRef.current && !azioniRef.current.contains(e.target as Node)) {
        setAzioniOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const filteredData = initialFaqs.filter(item => {
    const matchesSearch = item.domanda.toLowerCase().includes(searchQuery.toLowerCase()) || item.risposta.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesFilters = item.domanda.toLowerCase().includes(filters.domanda.toLowerCase()) && item.risposta.toLowerCase().includes(filters.risposta.toLowerCase()) && (filters.categoria === 'TUTTI' || item.categoria === filters.categoria) && (filters.tag === '' || item.tags.some(t => t.toLowerCase().includes(filters.tag.toLowerCase())));
    return matchesSearch && matchesFilters;
  });
  const totalItems = 70;
  const startItem = (currentPage - 1) * rowsPerPage + 1;
  const endItem = Math.min(currentPage * rowsPerPage, totalItems);
  const handleFilterChange = (key: string, value: string) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
    setCurrentPage(1);
  };
  const iconBtnStyle: React.CSSProperties = {
    width: '36px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #E4E4E4',
    background: 'white',
    cursor: 'pointer',
    color: '#293B54',
    borderRadius: '8px',
    flexShrink: 0
  };
  return <div style={{
    fontFamily: 'Roboto, sans-serif'
  }} data-id="element-1122">
      {/* Page Header */}
      <div className="bg-white flex items-center justify-between" style={{
      padding: '24px 32px',
      border: CARD_BORDER,
      boxShadow: CARD_SHADOW,
      borderRadius: '8px'
    }} data-id="element-1123">
        <h1 style={{
        fontSize: '24px',
        fontWeight: 400,
        color: '#293B54',
        fontFamily: 'Roboto, sans-serif',
        margin: 0
      }} data-id="element-1124">
          Gestione FAQ
        </h1>

        {/* Right side controls */}
        <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      }} data-id="element-1125">
          {/* Plus icon button */}
          <button style={iconBtnStyle} title="Aggiungi FAQ" onMouseEnter={e => (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#f5f5f5'} onMouseLeave={e => (e.currentTarget as HTMLButtonElement).style.backgroundColor = 'white'} data-id="element-1126">
            <Icon icon="tabler:plus" fontSize={18} data-id="element-1127" />
          </button>

          {/* Smile icon button */}
          <button style={iconBtnStyle} title="Emoji" onMouseEnter={e => (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#f5f5f5'} onMouseLeave={e => (e.currentTarget as HTMLButtonElement).style.backgroundColor = 'white'} data-id="element-1128">
            <Icon icon="tabler:mood-smile" fontSize={18} data-id="element-1129" />
          </button>

          {/* AZIONI dropdown */}
          <div ref={azioniRef} style={{
          position: 'relative'
        }} data-id="element-1130">
            <button onClick={() => setAzioniOpen(!azioniOpen)} style={{
            backgroundColor: '#293B54',
            color: '#FFFFFF',
            fontFamily: 'Roboto Condensed, sans-serif',
            fontSize: '14px',
            fontWeight: 400,
            padding: '10px 16px',
            borderRadius: '9999px',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }} onMouseEnter={e => (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#1e2b3e'} onMouseLeave={e => (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#293B54'} data-id="element-1131">
              Azioni
              <Icon icon="tabler:chevron-down" fontSize={16} data-id="element-1132" />
            </button>

            {azioniOpen && <div style={{
            position: 'absolute',
            right: 0,
            top: 'calc(100% + 4px)',
            backgroundColor: 'white',
            border: '1px solid #E4E4E4',
            boxShadow: 'rgba(47,43,61,0.14) 0px 4px 12px',
            zIndex: 50,
            minWidth: '160px'
          }} data-id="element-1133">
                {['Esporta CSV', 'Importa FAQ', 'Ordina FAQ'].map(action => <button key={action} onClick={() => setAzioniOpen(false)} style={{
              width: '100%',
              textAlign: 'left',
              padding: '10px 16px',
              fontSize: '14px',
              fontFamily: 'Roboto, sans-serif',
              color: '#293B54',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              borderBottom: '1px solid #f5f5f5'
            }} onMouseEnter={e => (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#f5f5f5'} onMouseLeave={e => (e.currentTarget as HTMLButtonElement).style.backgroundColor = 'transparent'} data-id="element-1134">
                    {action}
                  </button>)}
              </div>}
          </div>
        </div>
      </div>

      {/* Table Container */}
      <div className="bg-white" style={{
      marginTop: '24px',
      padding: '24px',
      border: CARD_BORDER,
      boxShadow: CARD_SHADOW
    }} data-id="element-1135">
        {/* Search Row */}
        <div className="flex items-center gap-3 mb-4" data-id="element-1136">
          <div className="relative" style={{
          width: '300px'
        }} data-id="element-1137">
            <Icon icon="tabler:search" fontSize={16} style={{
            position: 'absolute',
            left: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#AAAAAA'
          }} data-id="element-1138" />
            <input type="text" placeholder="Cerca nelle FAQ..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} style={{
            width: '100%',
            height: '36px',
            paddingLeft: '32px',
            paddingRight: '10px',
            border: '1px solid #E4E4E4',
            borderRadius: '9999px 0 0 9999px',
            fontSize: '14px',
            fontFamily: 'Roboto, sans-serif',
            outline: 'none',
            color: '#293B54'
          }} onFocus={e => e.target.style.borderColor = '#293B54'} onBlur={e => e.target.style.borderColor = '#E4E4E4'} data-id="element-1139" />
          </div>
          <button style={{
          width: '36px',
          height: '36px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px solid #E4E4E4',
          background: 'white',
          cursor: 'pointer',
          color: '#666',
          borderRadius: '0 9999px 9999px 0'
        }} data-id="element-1140">
            <Icon icon="tabler:adjustments-horizontal" fontSize={16} data-id="element-1141" />
          </button>
        </div>

        {/* Table */}
        <div style={{
        overflowX: 'auto'
      }} data-id="element-1142">
          <table style={{
          width: '100%',
          borderCollapse: 'collapse',
          minWidth: '1000px'
        }} data-id="element-1143">
            <thead data-id="element-1144">
              {/* Header Row */}
              <tr style={{
              backgroundColor: '#FFFFFF'
            }} data-id="element-1145">
                {[{
                label: 'Domanda',
                width: '22%'
              }, {
                label: 'Risposta',
                width: '22%'
              }, {
                label: 'Categorie',
                width: '20%'
              }, {
                label: 'Tag',
                width: '26%'
              }, {
                label: 'Azioni',
                width: '10%'
              }].map(col => <th key={col.label} style={{
                textAlign: 'left',
                padding: '12px 16px',
                fontSize: '12px',
                fontWeight: 600,
                color: '#666',
                letterSpacing: '0.5px',
                textTransform: 'uppercase',
                borderBottom: '2px solid #E4E4E4',
                fontFamily: 'Roboto, sans-serif',
                width: col.width
              }} data-id="element-1146">
                    {col.label}
                  </th>)}
              </tr>

              {/* Filter Row */}
              <tr style={{
              backgroundColor: '#fafafa'
            }} data-id="element-1147">
                <td style={{
                padding: '6px 8px'
              }} data-id="element-1148">
                  <input type="text" placeholder="Filtra domanda..." value={filters.domanda} onChange={e => handleFilterChange('domanda', e.target.value)} style={filterInputStyle} data-id="element-1149" />
                </td>
                <td style={{
                padding: '6px 8px'
              }} data-id="element-1150">
                  <input type="text" placeholder="Filtra risposta..." value={filters.risposta} onChange={e => handleFilterChange('risposta', e.target.value)} style={filterInputStyle} data-id="element-1151" />
                </td>
                <td style={{
                padding: '6px 8px'
              }} data-id="element-1152">
                  <select value={filters.categoria} onChange={e => handleFilterChange('categoria', e.target.value)} style={filterSelectStyle} data-id="element-1153">
                    {categorieOptions.map(opt => <option key={opt} value={opt} data-id="element-1154">
                        {opt}
                      </option>)}
                  </select>
                </td>
                <td style={{
                padding: '6px 8px'
              }} data-id="element-1155">
                  <input type="text" placeholder="TUTTI" value={filters.tag} onChange={e => handleFilterChange('tag', e.target.value)} style={filterInputStyle} data-id="element-1156" />
                </td>
                <td style={{
                padding: '6px 8px'
              }} data-id="element-1157"></td>
              </tr>
            </thead>

            <tbody data-id="element-1158">
              {filteredData.map(row => <tr key={row.id} style={{
              borderBottom: '1px solid #f0f0f0'
            }} onMouseEnter={e => (e.currentTarget as HTMLTableRowElement).style.backgroundColor = '#fafafa'} onMouseLeave={e => (e.currentTarget as HTMLTableRowElement).style.backgroundColor = 'transparent'} data-id="element-1159">
                  <td style={{
                padding: '12px 16px',
                fontSize: '14px',
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif',
                maxWidth: '220px'
              }} data-id="element-1160">
                    {row.domanda}
                  </td>
                  <td style={{
                padding: '12px 16px',
                fontSize: '14px',
                color: '#444',
                fontFamily: 'Roboto, sans-serif',
                maxWidth: '220px'
              }} data-id="element-1161">
                    {row.risposta}
                  </td>
                  <td style={{
                padding: '12px 16px'
              }} data-id="element-1162">
                    <CategoriaBadge label={row.categoria} data-id="element-1163" />
                  </td>
                  <td style={{
                padding: '12px 16px'
              }} data-id="element-1164">
                    <div style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '2px'
                }} data-id="element-1165">
                      {row.tags.map((tag, i) => <TagPill key={i} label={tag} data-id="element-1166" />)}
                    </div>
                  </td>
                  <td style={{
                padding: '12px 16px'
              }} data-id="element-1167">
                    <div style={{
                  display: 'flex',
                  gap: '8px',
                  alignItems: 'center'
                }} data-id="element-1168">
                      <button style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#666',
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center'
                  }} onMouseEnter={e => (e.currentTarget as HTMLButtonElement).style.color = '#293B54'} onMouseLeave={e => (e.currentTarget as HTMLButtonElement).style.color = '#666'} title="Modifica" data-id="element-1169">
                        <Icon icon="tabler:pencil" fontSize={18} data-id="element-1170" />
                      </button>
                      <button style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#d32f2f',
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center'
                  }} onMouseEnter={e => (e.currentTarget as HTMLButtonElement).style.color = '#b71c1c'} onMouseLeave={e => (e.currentTarget as HTMLButtonElement).style.color = '#d32f2f'} title="Elimina" data-id="element-1171">
                        <Icon icon="tabler:trash" fontSize={18} data-id="element-1172" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '16px',
        paddingTop: '12px',
        borderTop: '1px solid #E4E4E4',
        marginTop: '4px'
      }} data-id="element-1173">
          <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          fontSize: '13px',
          color: '#666',
          fontFamily: 'Roboto, sans-serif'
        }} data-id="element-1174">
            <span data-id="element-1175">Righe per pagina:</span>
            <select value={rowsPerPage} onChange={e => {
            setRowsPerPage(Number(e.target.value));
            setCurrentPage(1);
          }} style={{
            border: 'none',
            background: 'transparent',
            fontSize: '13px',
            color: '#666',
            fontFamily: 'Roboto, sans-serif',
            cursor: 'pointer',
            outline: 'none',
            fontWeight: 500
          }} data-id="element-1176">
              <option value={10} data-id="element-1177">10</option>
              <option value={25} data-id="element-1178">25</option>
              <option value={50} data-id="element-1179">50</option>
            </select>
          </div>
          <span style={{
          fontSize: '13px',
          color: '#666',
          fontFamily: 'Roboto, sans-serif'
        }} data-id="element-1180">
            {startItem}-{endItem} di {totalItems}
          </span>
          <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '2px'
        }} data-id="element-1181">
            <button onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1} style={{
            background: 'none',
            border: 'none',
            cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
            color: '#666',
            opacity: currentPage === 1 ? 0.4 : 1,
            padding: '4px',
            display: 'flex',
            alignItems: 'center'
          }} data-id="element-1182">
              <Icon icon="tabler:chevron-left" fontSize={20} data-id="element-1183" />
            </button>
            <button onClick={() => setCurrentPage(p => p + 1)} disabled={endItem >= totalItems} style={{
            background: 'none',
            border: 'none',
            cursor: endItem >= totalItems ? 'not-allowed' : 'pointer',
            color: '#666',
            opacity: endItem >= totalItems ? 0.4 : 1,
            padding: '4px',
            display: 'flex',
            alignItems: 'center'
          }} data-id="element-1184">
              <Icon icon="tabler:chevron-right" fontSize={20} data-id="element-1185" />
            </button>
          </div>
        </div>
      </div>
    </div>;
}